import type { ILabelCheckerProps } from './types'

export const onLabelCheckerClick = (props: ILabelCheckerProps<any>) => () => {
  if (!props.onClick || !props.codename) {
    return
  }
  props.onClick(props.codename, props.selected)
}
